import { createAction } from '@reduxjs/toolkit';

export const asyncCancelRequest = createAction('[CancelRequest] asyncCancelRequest');
export const asyncCancelRequestResponse = createAction('[CancelRequest] asyncCancelRequestResponse');
